import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home/Home';
import Login from './pages/Login/Login';
import MeetingList from './pages/Meeting/List/List';
import MeetingDetails from './pages/Meeting/Details/Details';
import ExpenseList from './pages/Expense/List/List';
import ExpenseDetails from './pages/Expense/Details/Details';
import MembershipList from './pages/Membership/List/List';
import Addresses from './pages/Settings/Addresses/Addresses';
import ActivityTypes from './pages/Settings/ActivityTypes/ActivityTypes';

const App = () => {
  return (
    <Routes>
      <Route index path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/meeting" element={<MeetingList />} />
      <Route path="/meeting/:id" element={<MeetingDetails />} />
      <Route path="/expense" element={<ExpenseList />} />
      <Route path="/expense/:id" element={<ExpenseDetails />} />
      <Route path="/membership" element={<MembershipList />} />
      <Route path="/addresses" element={<Addresses />} />
      <Route path="/activity-types" element={<ActivityTypes />} />
    </Routes>
  );
};

export default App;
